export default __webpack_public_path__ + "static/media/e0e09c1a-9f54-436d-acf3-dce82cdb649f.6d7a9a42.png";